import HttpFactory from '../factory'
import type { Place, Owner } from '../types/place'

class PlacesModule extends HttpFactory<any[]> {
  private RESOURCE = '/places'

  async get(owner: Owner): Promise<Place[]> {
    const result = await this.call<any>('GET', `${this.RESOURCE}?&ownerType=${owner.type}&ownerId=${owner.id}`)
    return result.items
  }

  async getPlaceById(id: string) {
    return await this.call<any>('GET', `${this.RESOURCE}/${id}`)
  }

  async save(obj: Partial<Place>): Promise<Place> {
    if (obj.id) {
      return this.call<any>('PATCH', `${this.RESOURCE}/${obj.id}?revision=${obj.revision}`, {
        accessDetails: obj.accessDetails,
        accessibility: obj.accessibility,
        address: obj.address,
        name: obj.name,
        // contactPoints: obj.contactPoints,
      })
    } else {
      return this.call<any>('POST', `${this.RESOURCE}`, obj)
    }
  }

  async deletePlaceById(obj: Partial<Place>) {
    return await this.call<any>('DELETE', `${this.RESOURCE}/${obj.id}?revision=${obj.revision}`)
  }
}

export default PlacesModule
